var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 940,
    height: 304,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.333 17.999L0 .001v303.998L78.333 286l78.334 17.999L235 286.001 313.333 304l78.334-18L470 304l78.333-17.999L626.667 304 705 286.001 783.333 304l78.334-17.999L940 304V.001L861.667 18 783.333.001 705 17.999 626.667 0l-78.334 18L470 0l-78.333 18-78.334-18L235 17.999 156.667 0 78.333 17.999z",
    fill: "#E2F7FF"
  })));
}
export default SvgRibbon;